/**
 * A text field with email formatting. By default uses formatting
 * rules defined in the fiFormatter.js file. To change the formatting
 * provide alternative implementations for the format and parse functions
 * that are passed to the input field.
 */
import React from 'react';

import { FieldTextInput } from '..';

const FieldEmailInput = props => {
  const inputProps = {
    type: 'text',
    ...props,
  };

  return <FieldTextInput {...inputProps} />;
};

export default FieldEmailInput;
